window.addEventListener('changeViewMode',function (data) {
    $('.view-mode')
        .removeClass('view-mode-create').removeClass('view-mode-edit').removeClass('view-mode-list')
        .addClass('view-mode-' + data.detail.mode);

    $('.view-mode .card-title').html(data.detail.page_title);

    let page_title = APP_NAME + ' | ' + data.detail.page_title;
    $('head title').html(page_title);

    $('#datasetsTable').DataTable().draw(false)

    if(data.detail.current_page_url??null) {
        let newurl = data.detail.current_page_url;
        window.history.pushState({path:newurl}, page_title, newurl);
    }
})

window.confirmAndEmitEvent = function(...params) {
    let message = params.pop();
    console.log(params, message)

    var c = confirm(message);

    if (c == true) {

        Livewire.emit(...params);
    }
}

window.getAllValuesByElement = function(selector) {
    var values = [];
    if(typeof selector != 'Object') {

    }
    // $("input[name='directions']:checked")
    selector = $(selector);

    $.each(selector, function(){
        values.push($(this).val());
    });

    return values;
}


window.scrollTo = function(scrollToElement, scrollToContainer, gap = 100) {

    if(typeof scrollToElement != 'object') {
        scrollToElement = $(scrollToElement);
    }

    if(scrollToElement.length == 0) {
        return ;
    }

    if(!scrollToContainer) {
        scrollToContainer = $("html, body");
    }

    var position = scrollToElement.offset().top - scrollToContainer.offset().top;

    scrollToContainer.animate({ scrollTop: position - gap }, "slow");
}

window.scrollToTop = function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
}
$(document).on('click', '.copy-btn', function() {
    $('[role="tooltip"] .tooltip-inner').html('Copied!')
})

window.addEventListener('pageChanged', function (event, data) {
    scrollToTop();
})

window.addEventListener('scrollTo', function (event, data) {

    event.detail = event.detail??null;

    _.debounce(function () {
        scrollToTop();

        if(event.detail == 'top') {
            scrollToTop();
        } else if(event.detail && $(event.detail).length > 0) {
            scrollToTop($(event.detail));
        } else if($(".alert.alert-success:first").length > 0) {
            scrollTo($(".alert.alert-success:first"))
        } else if($(".alert.alert-danger:first").length > 0) {
            scrollTo($(".alert.alert-danger:first"))
        } else if($(".input-error:first").length > 0) {
            scrollTo($(".input-error:first"))
        }

    }, 100)();
})
